// extracted by mini-css-extract-plugin
export var container = "_7i-0";
export var error = "_7i-9";
export var label = "_7i-5";
export var light = "_7i-6";
export var md = "_7i-3";
export var sm = "_7i-2";
export var thin = "_7i-8";
export var thinBold = "_7i-7";
export var vertical = "_7i-4";
export var xs = "_7i-1";